<template lang="html">

  <section class="app-sidebar">
    <nav class="sidebar sidebar-offcanvas" id="sidebar">
      <ul class="nav">
        <li class="nav-item nav-profile">
          <div class="nav-link">
            <router-link to="/user/profile" class="profile-image d-flex"> 
            <img v-if="this.user.profile_image" :src="this.user.profile_image" alt="image"/> 
            <img src="../../assets/images/faces/avatardefault.png"  alt="image" v-else />
            <span class="online-status online"></span> </router-link>
            <div class="profile-name">
              <p class="name text-length">{{user.name?user.name:user.email}}</p>
              <p class="designation text-length">{{user.role?user.role.name:'Admin'}}</p>
            </div>
          </div>
        </li>
        <li  @click="collapedMobileSidebar()" class="nav-item"  value="true"
        v-for="(item, i) in menus"
        :key="i"
        :class="item.path === $route.path ? 'highlighted' : ''">
        <router-link class="nav-link" :to="item.path">
            <em :class="item.class"></em>
            <span class="menu-title nav-title">{{item.name}}</span>
          </router-link>
        </li>
      </ul>
    </nav>
  </section>

</template>

<script lang="js">
import { getSideMenu } from "@/shared/utils";

export default {
  name: 'app-sidebar',
  data(){
    return {
      user:{},
      menus:[
        {
          path : '/dashboard',
          name : 'Dashboard',
          module : null,
          class : "mdi mdi-view-dashboard text-primary icon-md"
        },
        {
          path : '/users',
          name : 'Users',
          module : 'User Management',
          class : "mdi mdi-account-box text-primary icon-md"
        },
        {
          path : '/admin/users',
          name : 'Admin Users',
          module : 'Admin Management',
          class : "mdi mdi-certificate text-primary icon-md"
        },
        {
          path : '/roles',
          name : 'Roles',
          module : 'Role Management',
          class:"mdi mdi-view-list text-primary icon-md"
        },
        {
          path : '/config',
          name : 'Configuration',
          module : 'Configuration Management',
          class:"mdi mdi-settings text-primary icon-md"
        },
        {
          path : '/fuel/capacity',
          name : 'Fuel Tank Capacity',
          module : 'Configuration Management',
          class:"mdi mdi-gas-cylinder text-primary icon-md"
        },
        {
          path : '/password/reset',
          name : 'Change Password',
          module : null,
          class : "mdi mdi-key-variant text-primary icon-md"
        }
      ]
    }
  },
  methods:{
    collapedMobileSidebar: () => {
      document.querySelector('.sidebar').classList.toggle('active')
    },
  },

  mounted() {
    window.addEventListener('user-localstorage-changed', (event) => {
      this.user = JSON.parse(event.detail.storage);
    });
 },
  
  created:function(){
    this.user = JSON.parse(localStorage.getItem("user"));
    this.menus = getSideMenu(this.menus,this.user.role.permissions,null);

  }
}
</script>

<style scoped lang="scss">
.highlighted{
  background:#c1e5ff;
}
.text-length{
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/AppSidebar.vue